import React, { useState } from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import { Typography, Box, Grid } from "@material-ui/core"
import { graphql } from "gatsby"
import { ProductCard } from "../components/ProductCard"
import { products } from "../config"
import { CartContext, ViewCart } from "../components/Context"
import search from "../lib/search"
const IndexPage = ({ data }) => {
  const [cartContext, setCartContext] = useState({
    cart: { userData: {}, products: [] },
    setCart: newCart => {
      setCartContext({ ...cartContext, cart: newCart })
    },
    money: data.sanitySetting.money,
  })
  let cartProducts = cartContext.cart.products
  const [valueViewCart, setViewCart] = useState(false)

  return (
    <ViewCart.Provider value={{ valueViewCart, setViewCart }}>
      <CartContext.Provider value={cartContext}>
        <Layout setting={data.sanitySetting}>
          <Grid container spacing={3}>
            {data.allSanityProduct.edges.map(({ node: product }, i) => {
              let productMatch = search(cartProducts, "id", product.id)
              return (
                <Grid key={product.id} item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <ProductCard
                    product={product}
                    viewCart={valueViewCart}
                    productMatchCart={productMatch || false}
                    shoppingCart={cartProducts}
                    setShoppingCart={newData => {
                      setCartContext({
                        ...cartContext,
                        cart: { ...cartContext.cart, products: newData },
                      })
                    }}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Layout>
      </CartContext.Provider>
    </ViewCart.Provider>
  )
}
export const query = graphql`
  query Data {
    allSanityProduct(sort: { order: ASC, fields: [title] }) {
      edges {
        node {
          description
          id
          img {
            asset {
              metadata {
                dimensions {
                  height
                  width
                }
              }
              url
              fluid {
                ...GatsbySanityImageFluid
              }
            }
            hotspot {
              height
              width
              x
              y
            }
          }
          price
          title
          variants {
            name
            tag
            list {
              img {
                asset {
                  metadata {
                    dimensions {
                      height
                      width
                    }
                  }
                  url
                  fluid {
                    ...GatsbySanityImageFluid
                  }
                }
                hotspot {
                  height
                  width
                  x
                  y
                }
              }
              description
              price
              tag
              title
            }
          }
        }
      }
    }
    sanitySetting {
      description
      logo {
        asset {
          url
        }
      }
      cover {
        asset {
          url
        }
      }
      title
      whatsapp {
        message
        phone
      }
      template
      money
    }
  }
`
export default IndexPage
